import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";
import DefaultAcordeon from "../elements/DefaultAcordeon";
import SelectWebsite from "../elements/SelectWebsite";
import Domain from "../elements/Domain";
import ConnectionTypes from "../elements/ConnectionType";
import Company from "../elements/Company";

import Styles from "bundle-text:../styles/_connectModal.scss";
import { translations as t } from "../../../services/context";

interface ConnectModalProps {
  show: boolean;
  onClose: () => void;
  onBack?: () => void;
  onSelect?: (type: string) => void;
  hasWebsite?: boolean;
  hasDomain?: boolean;
  hasConnectionType?: boolean;
  hasCompany?: boolean;
  isSubdomain?: boolean;
}

const ConnectModal: Component<ConnectModalProps> = (props) => {
  const [selectedWebsite, setSelectedWebsite] = createSignal("");
  const [selectedDomain, setSelectedDomain] = createSignal("");
  const [connectionType, setConnectionType] = createSignal("");
  const [company, setCompany] = createSignal("");

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={40}>
        <HeaderModal
          title={
            props.isSubdomain
              ? t["dns_connect_subdomain"]
              : t["dns_connect_domain"]
          }
          onClose={props.onClose}
        />
        <div class="connect-modal-content">
          <p>
            {props.isSubdomain
              ? t["dns_connect_sub_text"]
              : t["dns_connect_text"]}
          </p>
          <section>
            {props.hasWebsite && (
              <SelectWebsite
                websites={["Website 1", "Website 2", "Website 3"]}
                totalWebsites={5}
                onSelect={(website) => {
                  setSelectedWebsite(website);
                }}
              />
            )}

            {props.hasDomain && (
              <Domain
                domains={["domain1.com", "domain2.com", "domain3.com"]}
                totalDomains={5}
                isSubdomain={props.isSubdomain}
                onSelect={(domain) => {
                  setSelectedDomain(domain);
                }}
              />
            )}

            {props.hasConnectionType && (
              <ConnectionTypes
                onSelect={(type) => {
                  setConnectionType(type);
                }}
              />
            )}

            {props.hasCompany && (
              <Company
                companies={["Company 1", "Company 2", "Company 3"]}
                totalCompanies={5}
                onSelect={(company) => {
                  setCompany(company);
                }}
              />
            )}
          </section>
          <footer>
            <a href="#">{t["dns_n_have_domain"]}</a>
            <button
              onClick={() =>
                props.onSelect?.({
                  website: selectedWebsite(),
                  domain: selectedDomain(),
                  connectionType: connectionType(),
                })
              }
            >
              {t["dns_general_next"]}
            </button>
          </footer>
        </div>
      </DefaultModal>
    </>
  );
};
export default ConnectModal;
